import { Inbox, Send } from 'lucide-react';

const SidebarMail = ({ activeTab, setActiveTab, sentCount = 0 ,   onSentClick }) => {
  const sidebarItems = [
    { id: 'inbox', label: 'Inbox', icon: Inbox },
    { id: 'sent', label: 'Sent', icon: Send, count: sentCount },

  ];

  return (
    <div style={{ width: '261px', borderRight: '1px solid #e0e0e0', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '20px', borderBottom: '1px solid #e0e0e0' }}>
        <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold', color: '#333',  }}>Mail App</h2>
      </div>

      <nav style={{ padding: '10px 0', flex: 1 }}>
        {sidebarItems.map(({ id, label, icon: Icon, count }) => (
          <button
            key={id}
            onClick={() => setActiveTab(id)}
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              padding: '12px 20px',
              border: 'none',
              backgroundColor: activeTab === id ? '#e3f2fd' : '#fff',
              color: activeTab === id ? '#1976d2' : '#666',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: activeTab === id ? '600' : 'normal',
              transition: 'all 0.2s ease',
            }}
          >
            <Icon size={18} style={{ marginRight: '12px' }} />
            <span style={{ flex: 1, textAlign: 'left' }}>{label}</span>
            {/* {count > 0 && (
              <span style={{
                backgroundColor: '#ff4444',
                color: 'white',
                borderRadius: '10px',
                padding: '2px 8px',
                fontSize: '12px',
                fontWeight: 'bold',
                minWidth: '18px',
                textAlign: 'center',
              }}>{count}</span>
            )} */}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default SidebarMail;